import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientContainer = (props: Props) => {
  const { children } = props;

  const { match } = useResponsive();

  const containerStyles = match([
    styles.containerXS,
    styles.containerXS,
    styles.containerXS,
    styles.containerXL,
  ]);

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flexDirection: 'row',
    gap: theme.spacing['4'],
  },
  containerXL: {
    gap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
